.carouselViewport {
  position: relative;
  overflow: hidden;
  width: 100%;
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
  cursor: pointer;
  border-radius: 24px;
}

.carouselTrack {
  position: relative;
  transition: transform 0.3s;
  display: flex;
  align-items: center;
}

@media (prefers-reduced-motion: reduce) {
  .carouselTrack {
    transition: none;
  }
}
